module.exports = __webpack_public_path__ + "img/Oracle.d6f861c5.png";